<template>
  <generic-error>
    <template v-slot:title>Erreur dans l'URL</template>
    <h1>Accès non autorisé</h1>
    <p>
      Désolé, vous devez être connecté au portail sécurisé de l’Ordre pour avoir accès à ce formulaire. SVP, utilisez le bouton SE CONNECTER ou la
      fonction CRÉATION DE COMPTE.
    </p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
